import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PersonRoundedIcon from '@mui/icons-material/PersonRounded'
import ScaleRoundedIcon from '@mui/icons-material/ScaleRounded'
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone'
import YardOutlinedIcon from '@mui/icons-material/YardOutlined'

import type { MotivationModelScenario } from '@/types'

export default function ScenarioResults({
    scenario,
    isLoading,
}: {
    scenario: MotivationModelScenario,
    isLoading: boolean,
}) {

    const totalCitizensCount = scenario.categorized_households.sum_category.citizens_count

    const weightCategories = [
        {
            text: 'Kat.\xa01',
            severity: 1,
            color: 'categories.first',
            limit_weight: scenario.categorized_households.mixed_weight_categories[1].value_lt,
            amount_weight: scenario.categorized_households.mixed_weight_categories[1].discount_per_citizen/100,
            citizens_weight: scenario.categorized_households.mixed_weight_categories[1].citizens_count,
            percentage_weight: (scenario.categorized_households.mixed_weight_categories[1].citizens_count/(totalCitizensCount/100)).toFixed(2),
            limit_volume: scenario.categorized_households.mixed_volume_categories[1].value_lt,
            amount_volume: scenario.categorized_households.mixed_volume_categories[1].discount_per_citizen/100,
            citizens_volume: scenario.categorized_households.mixed_volume_categories[1].citizens_count,
            percentage_volume: (scenario.categorized_households.mixed_volume_categories[1].citizens_count/(totalCitizensCount/100)).toFixed(2),
            limit_bio: scenario.categorized_households.bio_weight_categories[1].value_lt,
            amount_bio: scenario.categorized_households.bio_weight_categories[1].discount_per_citizen/100,
            citizens_bio: scenario.categorized_households.bio_weight_categories[1].citizens_count,
            percentage_bio: (scenario.categorized_households.bio_weight_categories[1].citizens_count/(totalCitizensCount/100)).toFixed(2),
        },
        {
            text: 'Kat.\xa02',
            severity: 2,
            color: 'categories.second',
            limit_weight: scenario.categorized_households.mixed_weight_categories[2].value_lt,
            amount_weight: scenario.categorized_households.mixed_weight_categories[2].discount_per_citizen/100,
            citizens_weight: scenario.categorized_households.mixed_weight_categories[2].citizens_count,
            percentage_weight: (scenario.categorized_households.mixed_weight_categories[2].citizens_count/(totalCitizensCount/100)).toFixed(2),
            limit_volume: scenario.categorized_households.mixed_volume_categories[2].value_lt,
            amount_volume: scenario.categorized_households.mixed_volume_categories[2].discount_per_citizen/100,
            citizens_volume: scenario.categorized_households.mixed_volume_categories[2].citizens_count,
            percentage_volume: (scenario.categorized_households.mixed_volume_categories[2].citizens_count/(totalCitizensCount/100)).toFixed(2),
            limit_bio: scenario.categorized_households.bio_weight_categories[2].value_lt,
            amount_bio: scenario.categorized_households.bio_weight_categories[2].discount_per_citizen/100,
            citizens_bio: scenario.categorized_households.bio_weight_categories[2].citizens_count,
            percentage_bio: (scenario.categorized_households.bio_weight_categories[2].citizens_count/(totalCitizensCount/100)).toFixed(2),
        },
        {
            text: 'Kat.\xa03',
            severity: 3,
            color: 'categories.third',
            limit_weight: scenario.categorized_households.mixed_weight_categories[3].value_lt,
            amount_weight: scenario.categorized_households.mixed_weight_categories[3].discount_per_citizen/100,
            citizens_weight: scenario.categorized_households.mixed_weight_categories[3].citizens_count,
            percentage_weight: (scenario.categorized_households.mixed_weight_categories[3].citizens_count/(totalCitizensCount/100)).toFixed(2),
            limit_volume: scenario.categorized_households.mixed_volume_categories[3].value_lt,
            amount_volume: scenario.categorized_households.mixed_volume_categories[3].discount_per_citizen/100,
            citizens_volume: scenario.categorized_households.mixed_volume_categories[3].citizens_count,
            percentage_volume: (scenario.categorized_households.mixed_volume_categories[3].citizens_count/(totalCitizensCount/100)).toFixed(2),
            limit_bio: scenario.categorized_households.bio_weight_categories[3].value_lt,
            amount_bio: scenario.categorized_households.bio_weight_categories[3].discount_per_citizen/100,
            citizens_bio: scenario.categorized_households.bio_weight_categories[3].citizens_count,
            percentage_bio: (scenario.categorized_households.bio_weight_categories[3].citizens_count/(totalCitizensCount/100)).toFixed(2),
        },
        {
            text: 'Kat.\xa04',
            severity: 4,
            color: 'categories.fourth',
            limit_weight: scenario.categorized_households.mixed_weight_categories[4].value_lt,
            amount_weight: scenario.categorized_households.mixed_weight_categories[4].discount_per_citizen/100,
            citizens_weight: scenario.categorized_households.mixed_weight_categories[4].citizens_count,
            percentage_weight: (scenario.categorized_households.mixed_weight_categories[4].citizens_count/(totalCitizensCount/100)).toFixed(2),
            limit_volume: scenario.categorized_households.mixed_volume_categories[4].value_lt,
            amount_volume: scenario.categorized_households.mixed_volume_categories[4].discount_per_citizen/100,
            citizens_volume: scenario.categorized_households.mixed_volume_categories[4].citizens_count,
            percentage_volume: (scenario.categorized_households.mixed_volume_categories[4].citizens_count/(totalCitizensCount/100)).toFixed(2),
            limit_bio: scenario.categorized_households.bio_weight_categories[4].value_lt,
            amount_bio: scenario.categorized_households.bio_weight_categories[4].discount_per_citizen/100,
            citizens_bio: scenario.categorized_households.bio_weight_categories[4].citizens_count,
            percentage_bio: (scenario.categorized_households.bio_weight_categories[4].citizens_count/(totalCitizensCount/100)).toFixed(2),
        },
        {
            text: 'Kat.\xa05',
            severity: 5,
            color: 'categories.fifth',
            limit_weight: '∞',
            amount_weight: scenario.categorized_households.mixed_weight_categories[5].discount_per_citizen/100,
            citizens_weight: scenario.categorized_households.mixed_weight_categories[5].citizens_count,
            percentage_weight: (scenario.categorized_households.mixed_weight_categories[5].citizens_count/(totalCitizensCount/100)).toFixed(2),
            limit_volume: '∞',
            amount_volume: scenario.categorized_households.mixed_volume_categories[5].discount_per_citizen/100,
            citizens_volume: scenario.categorized_households.mixed_volume_categories[5].citizens_count,
            percentage_volume: (scenario.categorized_households.mixed_volume_categories[5].citizens_count/(totalCitizensCount/100)).toFixed(2),
            limit_bio: '∞',
            amount_bio: scenario.categorized_households.bio_weight_categories[5].discount_per_citizen/100,
            citizens_bio: scenario.categorized_households.bio_weight_categories[5].citizens_count,
            percentage_bio: (scenario.categorized_households.bio_weight_categories[5].citizens_count/(totalCitizensCount/100)).toFixed(2),
        },
    ]

    const notInProgram = [
        {
            text: 'Občané',
            value: scenario.categorized_households.not_in_program_categories[0].citizens_count,
        },
        {
            text: 'Svoz. místa',
            value: scenario.categorized_households.not_in_program_categories[0].household_count,
        },
        {
            text: 'Fixní sleva',
            value: `${scenario.categorized_households.not_in_program_categories[0].discount_per_category/100}\xa0Kč`,
        },
    ]
    
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: {
                xs: 'column',
                sm: 'row',
            },
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: 3,
            mt: 4,
            opacity: isLoading ? 0.3 : 'unset',
        }}>
            <Box maxWidth="100%">
                <Box sx={{
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                    pb: 1.5,
                }}>
                    <ScaleRoundedIcon />
                    <Typography variant="h5" component="h3">
                        Predikce kategorií dle hmotnosti
                    </Typography>
                </Box>
                <Box sx={(theme) => ({
                    borderRadius: 2.5,
                    border: `1px solid ${theme.palette.divider}`,
                    px: 3,
                    py: 1.5,
                    color: theme.palette.customGrey.tableText,
                    overflow: 'auto',
                })}>
                    <table style={{ width: '100%' }}>
                        <tbody>
                            <tr>
                                <td style={{ paddingBottom: '0.375rem' }}>
                                    <Typography variant="h5" component="span">
                                        Kat.
                                    </Typography>
                                </td>
                                <td style={{ textAlign: 'center', paddingLeft: '1rem', paddingBottom: '0.375rem' }}>
                                    <Typography variant="h5" component="span">
                                        Limit
                                    </Typography>
                                </td>
                                <td style={{ textAlign: 'center', paddingLeft: '1rem', paddingBottom: '0.375rem' }}>
                                    <Typography variant="h5" component="span">
                                        Sleva
                                    </Typography>
                                </td>
                                <td style={{ textAlign: 'center', paddingLeft: '1rem', paddingBottom: '0.375rem'}}>
                                    <Typography variant="h5" component="span">
                                        Počet
                                    </Typography>
                                    <PersonRoundedIcon sx={{ fontSize: '1.2rem', ml: 0.5, mb: -0.5, }}/>
                                </td>
                                <td style={{ textAlign: 'center', paddingLeft: '1rem', paddingBottom: '0.375rem' }}>
                                    <Typography variant="h5" component="span">
                                        Podíl
                                    </Typography>
                                    <PersonRoundedIcon sx={{ fontSize: '1.2rem', ml: 0.5, mb: -0.5, }}/>
                                </td>
                            </tr>
                            {weightCategories.map(category => (
                                <tr key={category.text}>
                                    <td>
                                        <Box sx={{
                                            backgroundColor: category.color,
                                            width: 22,
                                            height: 22,
                                            borderRadius: 10,
                                            color: 'white',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}>
                                            {category.severity}
                                        </Box>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '1rem' }}>
                                        <Box component="span">
                                            {category.limit_weight}&nbsp;kg
                                        </Box>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '1rem' }}>
                                        <Box component="span">
                                            {category.amount_weight}&nbsp;Kč
                                        </Box>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '1rem' }}>
                                        <Box component="span">
                                            {category.citizens_weight}
                                        </Box>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '1rem' }}>
                                        <Box component="span">
                                            {category.percentage_weight}%
                                        </Box>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Box>
            </Box>
            <Box maxWidth="100%">
                <Box sx={{
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                    pb: 1.5,
                }}>
                    <DeleteTwoToneIcon />
                    <Typography variant="h5" component="h3">
                        Predikce kategorií dle objemu
                    </Typography>
                </Box>
                <Box sx={(theme) => ({
                    borderRadius: 2.5,
                    border: `1px solid ${theme.palette.divider}`,
                    px: 3,
                    py: 1.5,
                    color: theme.palette.customGrey.tableText,
                    overflow: 'auto',
                })}>
                    <table style={{ width: '100%' }}>
                        <tbody>
                            <tr>
                                <td style={{ paddingBottom: '0.375rem' }}>
                                    <Typography variant="h5" component="span">
                                        Kat.
                                    </Typography>
                                </td>
                                <td style={{ textAlign: 'center', paddingLeft: '1rem', paddingBottom: '0.375rem' }}>
                                    <Typography variant="h5" component="span">
                                        Limit
                                    </Typography>
                                </td>
                                <td style={{ textAlign: 'center', paddingLeft: '1rem', paddingBottom: '0.375rem' }}>
                                    <Typography variant="h5" component="span">
                                        Sleva
                                    </Typography>
                                </td>
                                <td style={{ textAlign: 'center', paddingLeft: '1rem', paddingBottom: '0.375rem'}}>
                                    <Typography variant="h5" component="span">
                                        Počet
                                    </Typography>
                                    <PersonRoundedIcon sx={{ fontSize: '1.2rem', ml: 0.5, mb: -0.5, }}/>
                                </td>
                                <td style={{ textAlign: 'center', paddingLeft: '1rem', paddingBottom: '0.375rem' }}>
                                    <Typography variant="h5" component="span">
                                        Podíl
                                    </Typography>
                                    <PersonRoundedIcon sx={{ fontSize: '1.2rem', ml: 0.5, mb: -0.5, }}/>
                                </td>
                            </tr>
                            {weightCategories.map(category => (
                                <tr key={category.text}>
                                    <td>
                                        <Box sx={{
                                            backgroundColor: category.color,
                                            width: 22,
                                            height: 22,
                                            borderRadius: 10,
                                            color: 'white',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}>
                                            {category.severity}
                                        </Box>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '1rem' }}>
                                        <Box component="span">
                                            {category.limit_volume}&nbsp;l
                                        </Box>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '1rem' }}>
                                        <Box component="span">
                                            {category.amount_volume}&nbsp;Kč
                                        </Box>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '1rem' }}>
                                        <Box component="span">
                                            {category.citizens_volume}
                                        </Box>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '1rem' }}>
                                        <Box component="span">
                                            {category.percentage_volume}%
                                        </Box>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Box>
            </Box>
            <Box maxWidth="100%">
                <Box sx={{
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                    pb: 1.5,
                }}>
                    <YardOutlinedIcon />
                    <Typography variant="h5" component="h3">
                        Predikce kategorií dle bio
                    </Typography>
                </Box>
                <Box sx={(theme) => ({
                    borderRadius: 2.5,
                    border: `1px solid ${theme.palette.divider}`,
                    px: 3,
                    py: 1.5,
                    color: theme.palette.customGrey.tableText,
                    overflow: 'auto',
                })}>
                    <table style={{ width: '100%' }}>
                        <tbody>
                            <tr>
                                <td style={{ paddingBottom: '0.375rem' }}>
                                    <Typography variant="h5" component="span">
                                        Kat.
                                    </Typography>
                                </td>
                                <td style={{ textAlign: 'center', paddingLeft: '1rem', paddingBottom: '0.375rem' }}>
                                    <Typography variant="h5" component="span">
                                        Limit
                                    </Typography>
                                </td>
                                <td style={{ textAlign: 'center', paddingLeft: '1rem', paddingBottom: '0.375rem' }}>
                                    <Typography variant="h5" component="span">
                                        Sleva
                                    </Typography>
                                </td>
                                <td style={{ textAlign: 'center', paddingLeft: '1rem', paddingBottom: '0.375rem'}}>
                                    <Typography variant="h5" component="span">
                                        Počet
                                    </Typography>
                                    <PersonRoundedIcon sx={{ fontSize: '1.2rem', ml: 0.5, mb: -0.5, }}/>
                                </td>
                                <td style={{ textAlign: 'center', paddingLeft: '1rem', paddingBottom: '0.375rem' }}>
                                    <Typography variant="h5" component="span">
                                        Podíl
                                    </Typography>
                                    <PersonRoundedIcon sx={{ fontSize: '1.2rem', ml: 0.5, mb: -0.5, }}/>
                                </td>
                            </tr>
                            {weightCategories.map(category => (
                                <tr key={category.text}>
                                    <td>
                                        <Box sx={{
                                            backgroundColor: category.color,
                                            width: 22,
                                            height: 22,
                                            borderRadius: 10,
                                            color: 'white',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}>
                                            {category.severity}
                                        </Box>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '1rem' }}>
                                        <Box component="span">
                                            {category.limit_bio}&nbsp;kg
                                        </Box>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '1rem' }}>
                                        <Box component="span">
                                            {category.amount_bio}&nbsp;Kč
                                        </Box>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '1rem' }}>
                                        <Box component="span">
                                            {category.citizens_bio}
                                        </Box>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '1rem' }}>
                                        <Box component="span">
                                            {category.percentage_bio}%
                                        </Box>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Box>
            </Box>
            <Box>
                <Typography variant="h5" component="h3" mb={2} textAlign="center">
                    Občané vyjmutí z motivačního modelu
                </Typography>
                <Box sx={(theme) => ({
                    borderRadius: 2.5,
                    border: `1px solid ${theme.palette.divider}`,
                    px: 3,
                    py: 1.5,
                    color: theme.palette.customGrey.tableText,
                })}>
                    <table style={{ width: '100%' }}>
                        <tbody>
                            {notInProgram.map(row => (
                                <tr key={row.text}>
                                    <td>
                                        <Typography variant="h5" component="span">
                                            {row.text}
                                        </Typography>
                                    </td>
                                    <td style={{ textAlign: 'right', paddingLeft: '2rem' }}>
                                        <Box component="span">
                                            {row.value}
                                        </Box>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Box>
            </Box>
        </Box>
    )
}
